import React, { FC } from 'react';

import { Control, Controller } from 'react-hook-form';

import { Autocomplete, Box, GridLegacy as Grid, TextField } from '@mui/material';

interface SubCategoryTagSelectorProps {
  promoTagArrays: App.PromoTagArrays;
  promoTagSelections: {
    selectedDepartment: string | null;
    selectedCategory: string | null;
    selectedSubCategory: string | null;
  };
  setPromoTagSelection: (
    deptTag: string,
    categoryTag?: string,
    subCategoryTag?: string,
  ) => {
    selectedDepartment: string | null;
    selectedCategory: string | null;
    selectedSubCategory: string | null;
  };
  isPromoMetaLoading: boolean;

  // Form-specific props
  formType: 'react-hook-form' | 'rjsf';
  // React Hook Form props
  control?: Control<any>;
  // RJSF props
  formData?: any;
  onFormChange?: (evt: any) => void;
  // Custom input props
  allowCustomInput?: boolean;
  isErroring?: boolean;
}

const SubCategoryTagSelector: FC<SubCategoryTagSelectorProps> = ({
  promoTagArrays,
  promoTagSelections,
  setPromoTagSelection,
  isPromoMetaLoading,
  formType,
  control,
  formData,
  onFormChange,
  allowCustomInput = false,
  isErroring = false,
}) => {
  if (isPromoMetaLoading || promoTagArrays == null || promoTagArrays.categoryTags.length === 0) {
    return null;
  }

  const handleChange = (newValue: string | null) => {
    if (formType === 'rjsf' && onFormChange && formData) {
      const updatedFormData = {
        ...formData,
        sub_category_tag: newValue,
      };

      onFormChange({
        formData: updatedFormData,
      });
    }

    setPromoTagSelection(promoTagSelections.selectedDepartment, promoTagSelections.selectedCategory, newValue);
  };

  const renderOption = (props: any, option: string) => {
    return (
      <Box component="li" {...props}>
        {option}
      </Box>
    );
  };

  if (formType === 'react-hook-form' && control) {
    return (
      <Controller
        key="sub_category_tag"
        name="sub_category_tag"
        rules={{ required: true }}
        control={control}
        render={({ field }) => (
          <Grid item xs={4}>
            <Autocomplete
              {...field}
              value={promoTagSelections.selectedSubCategory || ''}
              options={promoTagArrays.subCategoryTags}
              freeSolo={allowCustomInput}
              renderOption={renderOption}
              renderInput={(params) => (
                <TextField
                  name="sub_category_tag"
                  required
                  {...params}
                  variant="outlined"
                  label="Sub Category"
                  helperText={allowCustomInput ? 'Type to search or enter custom value' : undefined}
                  error={isErroring}
                />
              )}
              onChange={(e: unknown, newValue: string | null) => {
                field.onChange(newValue);
                handleChange(newValue);
              }}
            />
          </Grid>
        )}
      />
    );
  }

  // RJSF version
  return (
    <Grid item xs={4}>
      <Autocomplete
        value={promoTagSelections.selectedSubCategory || ''}
        options={promoTagArrays.subCategoryTags}
        freeSolo={allowCustomInput}
        renderOption={renderOption}
        renderInput={(params) => (
          <TextField
            name="sub_category_tag"
            required
            {...params}
            variant="outlined"
            label="Sub Category"
            error={isErroring}
            helperText={allowCustomInput ? 'Type to search or enter custom value' : undefined}
          />
        )}
        onChange={(e: unknown, newValue: string | null) => {
          handleChange(newValue);
        }}
      />
    </Grid>
  );
};

export default SubCategoryTagSelector;
